import { objKeyAsString, TimeFrame } from 'utils/customTypes';
import { EntityFilters } from '../types/filters';
import { EDIT_BUDGET_TABS } from 'utils/constants';

export const BUDGET_TABLE_FILTERS = {
  PROGRAMS: 'programId',
  PROJECTS: 'projectId',
  TEAMS: 'learningTeamId',
  VENDORS: 'vendorId',
  BUDGET_SOURCES: 'budgetSource',
  ADDITIONAL_FLAGS: 'additionalFlags',
  BUDGET_ID: 'budgetId',
};

export const BUDGET_ADDITONAL_FLAGS: objKeyAsString = {
  COST_OF_LABOR: 'costOfLabor',
};

export type BudgetFiltersKey =
  typeof BUDGET_TABLE_FILTERS[keyof typeof BUDGET_TABLE_FILTERS];
export type BudgetFilters = EntityFilters<BudgetFiltersKey>;

export enum ActualTimes {
  FISCAL_CURRENT = 'fiscal-current',
  FISCAL_NEXT = 'fiscal-next',
}

export type UpdateLineItemActualsRequest = {
  budgetId: string;
  lineItemId?: string;
  actual?: number;
  months?: string[];
};

export type BudgetSettings = {
  id?: string;
  fiscalYearStartMonth: number;
  fiscalYearStartDay: number;
  timeFrame: TimeFrame;
  organizationId?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
};

export type UpdateBudgetSettingsRequest = {
  timeFrame?: TimeFrame;
  day?: number;
  month?: number;
};

export const BUDGET_CSV_EXPORT_CONSTANTS: Record<
  string,
  { KEY: string; label: string }
> = {
  DESCRIPTION: {
    KEY: 'description',
    label: 'Description',
  },
  TEAM: {
    KEY: 'team',
    label: 'Team',
  },
  PROGRAM_OR_PROJECT: {
    KEY: 'programOrProject',
    label: 'Program or Project',
  },
  VENDOR: {
    KEY: 'vendor',
    label: 'Vendor',
  },
  BUDGET_SOURCE: {
    KEY: 'budgetSource',
    label: 'Budget Source',
  },
  PROJECT: {
    KEY: 'project',
    label: 'Project',
  },
  PROGRAM: {
    KEY: 'program',
    label: 'Program',
  },
  NOTES: {
    KEY: 'notes',
    label: 'Notes',
  },
  FISCAL_YEAR: {
    KEY: 'fiscalYear',
    label: 'Fiscal Year',
  },
  REPORT_SECTION_ALLOCATED: {
    KEY: 'reportSectionAllocated',
    label: 'Allocated',
  },
  REPORT_SECTION_ACTUALS: {
    KEY: 'reportSectionActuals',
    label: 'Actuals',
  },
  REPORT_SECTION_VARIANCE: {
    KEY: 'reportSectionVariance',
    label: 'Variance',
  },
  REPORT_FISCAL_YEAR_ALLOCATED: {
    KEY: 'reportFiscalYearAllocated',
    label: 'Allocated',
  },
  REPORT_FISCAL_YEAR_ACTUALS: {
    KEY: 'reportFiscalYearActuals',
    label: 'Actuals',
  },
  REPORT_FISCAL_YEAR_VARIANCE: {
    KEY: 'reportFiscalYearVariance',
    label: 'Variance',
  },
};

export const BUDGET_CSV_HEADER_SERIAL = {
  [EDIT_BUDGET_TABS.PROGRAM_OR_PROJECT]: [
    'DESCRIPTION',
    'PROGRAM',
    'PROJECT',
    'TEAM',
    'BUDGET_SOURCE',
    'VENDOR',
  ],
  [EDIT_BUDGET_TABS.TEAMS]: [
    'DESCRIPTION',
    'TEAM',
    'PROGRAM',
    'PROJECT',
    'BUDGET_SOURCE',
    'VENDOR',
  ],
  [EDIT_BUDGET_TABS.VENDORS]: [
    'DESCRIPTION',
    'VENDOR',
    'TEAM',
    'PROGRAM',
    'PROJECT',
    'BUDGET_SOURCE',
  ],
};
